class ScarfholdLooksTeaser {
  constructor(section) {
    this.section = section;
    this.observer = null;
    this.init();
  }

  init() {
    if (this.section.dataset.motionEnabled !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    this.section.classList.add('is-motion-ready');

    if (!('IntersectionObserver' in window)) {
      this.section.classList.add('is-in-view');
      return;
    }

    this.observer = new IntersectionObserver(
      ([entry]) => this.section.classList.toggle('is-in-view', entry.isIntersecting),
      { rootMargin: '100px 0px' }
    );
    this.observer.observe(this.section);
  }
}

const initScarfholdLooksTeasers = (scope = document) => {
  scope.querySelectorAll('[data-scarfhold-looks-teaser]:not([data-initialized])').forEach((section) => {
    section.dataset.initialized = 'true';
    new ScarfholdLooksTeaser(section);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initScarfholdLooksTeasers(), { once: true });
} else {
  initScarfholdLooksTeasers();
}

document.addEventListener('shopify:section:load', (event) => initScarfholdLooksTeasers(event.target));
